import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { accountActions } from '../../redux/actions';
import { Modal, Row, Radio, Select, Input, Typography, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import AccountPicker from '../AccountPicker';
import AccountPickerByNumber from '../AccountPickerByNumber';
import './styles.scss';

const { Title, Text } = Typography;



// Flatten an account tree into a list of pickable accounts.
// Skips accounts without an account_number (group headers, etc)


const ChooseBcCombine = ({ accountStructure, isChooseBcCombineOpen, setIsChooseBcCombineOpen, mainAccount }) => {
    const dispatch = useDispatch();
    const updatingAccount = useSelector((state) => state.accounts.updatingAccount);

    const [bcCombine, setBcCombine] = useState('sum');
    const [bcWeight, setBcWeight] = useState(undefined);

    useEffect(() => {
         if (!mainAccount) return;
    setBcCombine(mainAccount.bc_combine || 'sum');
    setBcWeight(mainAccount.bc_weight || undefined);
}, [mainAccount]);


    const handleOk = () => {
    const updateAccount = { ...mainAccount };
    updateAccount.bc_combine = bcCombine;
    updateAccount.bc_weight = bcCombine === 'weighted_avg' ? (bcWeight || null) : null;

    if (!updatingAccount) {
        dispatch(accountActions.updateAccount(mainAccount, updateAccount));
    }
    handleCancel();
};

    const handleCancel = () => {
        setIsChooseBcCombineOpen(false);
    };

    const onChangeMode = (e) => {
        setBcCombine(e.target.value);
    };

    const isValid = bcCombine !== 'weighted_avg' || (bcWeight && bcWeight.trim() !== '');


       return (
        <Modal
            bodyStyle={{
                minHeight: '30vh',
                display: 'flex',
                flexDirection: 'column',
            }}
            style={{
                minWidth: '50vh',
                display: 'flex',
                justifyContent: 'center',
            }}
            title="Business Case Behavior"
            visible={isChooseBcCombineOpen}
            onOk={handleOk}
            okButtonProps={{ disabled: !isValid }}
            confirmLoading={false}
            onCancel={handleCancel}
        >
            <div>
                <Text type="secondary" style={{ display: 'block', marginBottom: '20px' }}>
                    How should this account be combined when scenarios are assembled into a business case?
                </Text>

                <Radio.Group
                    onChange={onChangeMode}
                    value={bcCombine}
                    style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
                >
                    <Radio value="sum">
                        <Title level={5} style={{ display: 'inline', marginLeft: '8px' }}>
                            Sum of scenarios
                        </Title>
                        <Tooltip title="Add the values from each scenario together. Use for additive quantities like Revenue, Volume, Headcount.">
                            <InfoCircleOutlined style={{ marginLeft: '8px', color: '#999' }} />
                        </Tooltip>
                    </Radio>

                    <Radio value="weighted_avg">
                        <Title level={5} style={{ display: 'inline', marginLeft: '8px' }}>
                            Weighted average
                        </Title>
                        <Tooltip title="Compute a weighted average across scenarios using another account as the weight. Use for rates like Price (weighted by Volume) or Tax Rate (weighted by Profit).">
                            <InfoCircleOutlined style={{ marginLeft: '8px', color: '#999' }} />
                        </Tooltip>
                    </Radio>

                    {bcCombine === 'weighted_avg' && (
                        <Row style={{ marginLeft: '32px', flexDirection: 'column' }}>
                            <Text style={{ marginBottom: '4px', display: 'block' }}>
                                Weight account:
                            </Text>
                            <AccountPickerByNumber
                                accountStructure={accountStructure}
                                value={bcWeight}
                                onChange={setBcWeight}
                                style={{ width: '280px' }}
                            />
                        </Row>
                    )}

                    <Radio value="derive">
                        <Title level={5} style={{ display: 'inline', marginLeft: '8px' }}>
                            Calculate formula at business case level
                        </Title>
                        <Tooltip title="Don't aggregate this account directly. Instead, recompute its formula using business-case-level values for the inputs.">
                            <InfoCircleOutlined style={{ marginLeft: '8px', color: '#999' }} />
                        </Tooltip>
                    </Radio>
                </Radio.Group>
            </div>
        </Modal>
    );
};

export default ChooseBcCombine;